import { API_V1 } from '../config'
import { apiFetch } from './api'

export interface Actor {
  koblink_id: string
  actor_type: 'PERSON' | 'ORGANIZATION'
  display_name: string
  balance: string
  currency: string
  role?: string
  account_status: string
  isDeveloper: boolean
}

export interface Party {
  koblink_id?: string
  actor_type: 'PERSON' | 'ORGANIZATION'
  display_name: string
  full_name?: string
  email?: string
  document_count: number
  relationship_count: number
  is_legacy?: boolean
}

interface PartiesResponse {
  results: Party[]
  pagination: { total_count: number }
}

/** Fetch parties (actors with relationships) for a given actor */
export async function getParties(
  actorKoblinkId: string,
  type?: 'PERSON' | 'ORGANIZATION',
  search?: string,
): Promise<Party[]> {
  const params = new URLSearchParams({ page_size: '200' })
  if (type) params.set('type', type)
  if (search) params.set('search', search)

  const response = await apiFetch(
    `${API_V1}/actors/${encodeURIComponent(actorKoblinkId)}/parties/?${params}`,
  )
  if (!response.ok) {
    throw new Error(`Failed to fetch parties: ${response.status}`)
  }
  const data: PartiesResponse = await response.json()
  return data.results
}

/** Fetch all actors (personal + organizations) for the current user */
export async function getActors(): Promise<Actor[]> {
  const response = await apiFetch(`${API_V1}/actors/`)
  if (!response.ok) {
    throw new Error(`Failed to fetch actors: ${response.status}`)
  }
  return response.json()
}
